export default __webpack_public_path__ + "static/media/shape1.eb28e866.svg";